import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { toast } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { persistor, store } from "./app/store"; // Import persistor
import ErrorBoundary from "./components/Common/ErrorHandling/ErrorBoundary";
import TyreLoader from "./components/UniversalComponent/loaders/TyreLoader";
import "./i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ErrorHandler from "./utils/errorHandler";

ErrorHandler.init();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={<TyreLoader />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);

// Service worker registration with update handling
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log("Service worker registered successfully:", registration);
  },
  onUpdate: (registration) => {
    // Notify user of new content (e.g., via toast)
    if (toast) {
      toast.info("New version available! Click to update.", {
        onClick: () => {
          const waitingWorker = registration.waiting;
          if (waitingWorker) {
            waitingWorker.postMessage({ type: "SKIP_WAITING" });
            window.location.reload();
          }
        },
      });
    } else {
      // Fallback: Auto-reload on update
      const waitingWorker = registration.waiting;
      if (waitingWorker) {
        waitingWorker.postMessage({ type: "SKIP_WAITING" });
        window.location.reload();
      }
    }
  },
});

reportWebVitals((metric) => {
  if (metric.rating === "poor") {
    ErrorHandler.logError({
      type: "Web Vitals",
      name: metric.name,
      value: metric.value,
      delta: metric.delta,
      rating: metric.rating,
      navigationType: metric.navigationType,
      ...(process.env.NODE_ENV === "development" && {
        entries: metric.entries,
      }),
    });
  }

  if (process.env.NODE_ENV === "development") {
    console.log("[Web Vitals]", metric);
  }
});
